import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class HuoKe extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner">
          <div className="banner_cont">
            <h1>智能获客解决方案</h1>
            <p>我们能为合作机构提供涵盖多元化获客矩阵、精准流量触达、精细化营销管理的智能获客解决方案，通过线下覆盖全国的营业网点推荐优质客户，叠加线上的智能营销获客，借助线上线下一体化销售服务体系，实现优质客户广泛触达，助力合作机构高效精准获客。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel">
            <h2><span>覆盖全国的行销网络，精准捕捉优质客群</span></h2>
            <p>基于50家营业网点，配备移动销售管理系统，为金融机构发掘线下有消费金融服务相关需求的目标客户，并进行实时推荐，降低渠道成本，提升合作机构服务下沉能力。</p>
            <img src={require('./images/map.png')}/>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel">
            <h2><span>多元化获客矩阵+精准营销引擎，打造科技金融内核</span></h2>
            <p>线上获客体系涵盖信息流、应用商店、场景合作及自媒体渠道等多种主流获客形式，并可根据不同客户属性、客户生命周期部署精准营销引擎，全面分析及挖掘用户，实现为合作机构精准引流优质客户。 <br/>
              精准营销引擎，集合了先进的大数据和人工智能技术，能够精准刻画用户画像，并对用户进行有效分层，匹配不同营销策略，功能涵盖数据挖掘、营销模型、客群策略、产品匹配、数据监控、存量经营等模块，可根据合作伙伴的要求灵活配置。</p>
            <img className="pro_img" src={require('./images/pro_1.png')}/>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel">
            <h2><span>深耕消费金融 助力合作机构高效获客</span></h2>
            <p>中腾信深耕消费金融领域多年，对客群有深度理解，获客体系完善，销售运营经验丰富，渠道管理、投放效能、转化率经得起市场的验证，借助实战经验及多元获客渠道可帮助合作机构快速触达海量客群，针对合作机构的差异化营销需求精准匹配目标客群，有效规避流量层次不齐，合作机构无从下手的情况。</p>
          </div>
        </div>
      </div>
    )
  }
}


export default HuoKe



// WEBPACK FOOTER //
// ./modules/services/HuoKe.js